import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 16px;
`;

export const IconTextWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.text.text};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
`;

export const Text = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
`;
